// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"45":"a4aa8e4b","236":"4338501c","318":"f632386e","530":"60806b12","561":"0db389d7","793":"2b4623a7","812":"daa8112b","926":"42f8b9bb","964":"e0b307ba"}[chunkId] + ".css";
};